import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Room } from '../modal/room';

export const deleteRoomAPI = async (fieldId: string) => {
  const resp = await baseAPI.delete<Room>(`/custom-form/${fieldId}`);
  return resp.data;
};

export const useDeleteRoomMutation = () => {
  return useMutation({
    mutationFn: async ({ fieldId }: { fieldId: string }) => {
      const response = await deleteRoomAPI(fieldId);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.ROOMS,
      });
    },
  });
};
